import React from 'react'

const RoundedOverlay = (props) => {
  return (
    <svg viewBox="0 0 1920.008 164.932" {...props}>
      <path
        d="M0 1.637L1920.008 0v164.932s-434.042-72.975-948.731-72.305C525.493 92.627.008 164.932.008 164.932z"
        fill="#f2f0f0"
      />
    </svg>
  )
}

export default RoundedOverlay
